import lookups from "./lookups";
import { Post } from "./request";

export function Create(
  dispatch,
  successMessage,
  { Id, Name, Attributes },
  entityName,
  methodName
) {
  const method = methodName
    ? methodName
    : GetCreateMethod(entityName);
  ClearCache(entityName);
  // create or update the entity
  return Post(
    dispatch,
    "Create",
    successMessage,
    {
      Id,
      Name,
      Attributes,
    },
    method
  );
}

// For a record page whose definition names its own save, such as warehouse settings.
export function SaveRecordWithMethod(dispatch, method, data) {
  return Post(dispatch, method, "", data);
}

export function Update(
  dispatch,
  successMessage,
  { Id, Name, Attributes },
  entityName,
  methodName
) {
  const method = methodName
    ? methodName
    : GetUpdateMethod(entityName);
  ClearCache(entityName);
  // create or update the entity
  return Post(
    dispatch,
    "Update",
    successMessage,
    {
      Id,
      Name,
      Attributes,
    },
    method
  );
}

export function Delete(dispatch, id, entityName, methodName) {
  ClearCache(entityName);
  if (entityName === "list") {
    return Post(
      dispatch,
      "DeleteMarketingList",
      "Record successfully deleted",
      { Id: id }
    );
  } else {
    const method = methodName
      ? methodName
      : GetDeleteMethod(entityName);
    return Post(
      dispatch,
      "delete",
      "Record successfully deleted",
      { Id: id },
      method
    );
  }
}

export function SetRecordState(
  dispatch,
  { Ids, EntityName, StateCode }
) {
  ClearCache(EntityName);
  // update the status for the given records in the entity
  return Post(
    dispatch,
    "SetRecordState",
    StateCode === 0
      ? "Records successfully activated"
      : "Records successfully deactivated",
    {
      Ids,
      EntityName,
      StateCode,
    }
  );
}

export function ClearCache(entityName) {
  // clear the cache for the entity and its active and inactive records
  sessionStorage.removeItem(entityName);
  sessionStorage.removeItem(entityName + "-Active");
  sessionStorage.removeItem(entityName + "-Inactive");

  // clear the cache for the lookups
  const entityLookups = lookups[entityName];
  if (entityLookups) {
    for (const [key, lookup] of Object.entries(entityLookups)) {
      console.log(
        "Removing lookup from session storage.",
        `${key}: ${lookup.name}`
      );
      sessionStorage.removeItem(lookup.name);
    }
  }
}

export function GetCreateMethod(entityName) {
  switch (entityName) {
    case "dwautomation":
      return "entity/createentityrecord?entityName=dwautomation";
    case "dwcompetition":
      return "entity/createentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/createentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/createentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/createentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/createentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/createentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/createentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/createentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/createentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/createentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/createentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/createentityrecord?entityName=dwteam";
    case "dwtype":
      return "entity/createentityrecord?entityName=dwtype";
    case "account":
      return "ticketing/createaccount";
    case "campaign":
      return "ticketing/createcampaign";
    case "contact":
      return "ticketing/createcontact";
    case "customeraddress":
      return "ticketing/createcustomeraddress";
    case "dataimport":
      return "data-import/start-import";
    case "g4c_abtest":
      return "email-marketing/create-abtest";
    case "g4c_communication":
      return "email-marketing/create-communication";
    case "g4c_communicationaudience":
      return "email-marketing/create-communication-audience";
    case "g4c_communicationoptions":
      return "email-marketing/createcommunicationoptions";
    case "g4c_communicationsavedlayout":
      return "email-marketing/savecommunicationdesignaslayout";
    case "g4c_subscriptiongroup":
      return "ticketing/createsubscriptiongroup";
    case "g4c_triggerflow":
      return "email-marketing/create-trigger-flow";
    case "list":
      return "ticketing/createmarketinglist";
    case "warehouse-application":
    case "WarehouseApplication":
      return "configuration/warehouse-applications";
    default:
      throw new Error("No create method found for entity");
  }
}

export function GetUpdateMethod(entityName) {
  switch (entityName) {
    case "dwautomation":
      return "entity/updateentityrecord?entityName=dwautomation";
    case "dwcompetition":
      return "entity/updateentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/updateentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/updateentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/updateentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/updateentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/updateentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/updateentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/updateentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/updateentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/updateentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/updateentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/updateentityrecord?entityName=dwteam";
    case "dwtickethospitalityproduct":
      return "entity/updateentityrecord?entityName=dwtickethospitalityproduct";
    case "dwtype":
      return "entity/updateentityrecord?entityName=dwtype";
    case "account":
      return "ticketing/updateaccount";
    case "campaign":
      return "ticketing/updatecampaign";
    case "contact":
      return "ticketing/updatecontact";
    case "customeraddress":
      return "ticketing/updatecustomeraddress";
    case "g4c_abtest":
      return "email-marketing/update-abtest";
    case "g4c_communication":
      return "email-marketing/update-communication";
    case "g4c_communicationaudience":
      return "email-marketing/update-communication-audience";
    case "g4c_communicationoptions":
      return "email-marketing/updatecommunicationoptions";
    case "g4c_communicationsavedlayout":
      return "email-marketing/updatesavedcommunicationlayout";
    case "g4c_subscriptiongroup":
      return "ticketing/updatesubscriptiongroup";
    case "sitemap":
      return "sitemap/update";
    case "g4c_triggerflow":
      return `email-marketing/update-trigger-flow`;
    case "list":
      return "ticketing/updatemarketinglist";
    case "warehouse-application":
    case "WarehouseApplication":
      return "configuration/warehouse-applications";
    default:
      throw new Error("No update method found for entity");
  }
}

export function GetDeleteMethod(entityName) {
  switch (entityName) {
    case "dwcompetition":
      return "entity/deleteentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/deleteentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/deleteentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/deleteentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/deleteentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/deleteentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/deleteentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/deleteentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/deleteentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/deleteentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/deleteentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/deleteentityrecord?entityName=dwteam";
    case "dwtype":
      return "entity/deleteentityrecord?entityName=dwtype";
    default:
      throw new Error("No delete method found for entity");
  }
}
